export default __webpack_public_path__ + "static/media/Free_2_lowdef.9773cc93.png";